if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindNavigation();
      }

      bindNavigation() {
        if (this.dataset.navigationBound) return;
        this.dataset.navigationBound = 'true';
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        this.previousButton = this.querySelector('[data-product-modal-prev]');
        this.nextButton = this.querySelector('[data-product-modal-next]');
        this.container = this.querySelector('[role="document"]');
        this.previousButton?.addEventListener('click', () => this.showMediaAt(this.activeMediaIndex - 1));
        this.nextButton?.addEventListener('click', () => this.showMediaAt(this.activeMediaIndex + 1));
        this.touchStartX = null;
        this.container?.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        }, { passive: true });
        this.container?.addEventListener('touchend', (event) => {
          if (this.touchStartX === null) return;
          const distance = event.changedTouches[0]?.clientX - this.touchStartX;
          this.touchStartX = null;
          if (Math.abs(distance) < 40) return;
          this.showMediaAt(this.activeMediaIndex + (distance < 0 ? 1 : -1));
        }, { passive: true });
      }

      showMediaAt(index) {
        if (!this.mediaItems?.length) return;
        const normalizedIndex = (index + this.mediaItems.length) % this.mediaItems.length;
        const media = this.mediaItems[normalizedIndex];
        this.mediaItems.forEach((element) => element.classList.toggle('active', element === media));
        this.activeMediaIndex = normalizedIndex;
        media.scrollIntoView({ block: 'nearest', inline: 'center' });
        if (this.previousButton) this.previousButton.disabled = this.mediaItems.length < 2;
        if (this.nextButton) this.nextButton.disabled = this.mediaItems.length < 2;
        const mediaTemplate = media.querySelector('template');
        const mediaContent = mediaTemplate ? mediaTemplate.content : null;
        if (media.nodeName == 'DEFERRED-MEDIA' && mediaContent?.querySelector('.js-youtube')) media.loadContent();
      }

      showActiveMedia() {
        this.mediaItems = this.mediaItems || Array.from(this.querySelectorAll('[data-media-id]'));
        const openedMediaId = this.openedBy?.getAttribute('data-media-id');
        const activeIndex = this.mediaItems.findIndex((element) => element.getAttribute('data-media-id') === openedMediaId);
        this.showMediaAt(activeIndex >= 0 ? activeIndex : 0);
      }
    }
  );
}
